/*
* Copyright © 2021 Firecrest Clinical, Ltd.
* All rights reserved.
*/

import {
    Component,
    ViewEncapsulation,
    HostListener,
    Input, 
    DoCheck
} from '@angular/core';
import {FcResponsiveAgGridOptions} from './fc-responsive-ag-grid-options';

/**
 * Grid component with Angular.
 */
@Component({
    selector: 'fc-responsive-ag-grid-mode-button',
    templateUrl: './fc-responsive-ag-grid-mode-button.component.html',
    styleUrls: ['./fc-responsive-ag-grid-mode-button.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FcResponsiveAgGridModeButtonComponent implements DoCheck {

    private oldMobileWidth: number | undefined;
    
    /**
     * Flag to know if window width < gridOptions.mobileWidth.
     */
    isMobileWidth: boolean = false;
    
    /**
     * Fc Responsive Ag Grid Options.
     */
    @Input() gridOptions: FcResponsiveAgGridOptions;
    
    /**
     * Default constructor.
     */
    constructor() {
        
    }

    /**
     * Angular life cycle.
     */
    ngDoCheck() {
        if (this.oldMobileWidth !== this.gridOptions.mobileWidth) {
            this.handleWindowResize();
            this.oldMobileWidth = this.gridOptions.mobileWidth;
        }
    }
    
    /**
     * Toggle Mobile Mode to on or off.
     */
    toggleViewMode() {
        this.gridOptions.isMobileMode = !this.gridOptions.isMobileMode;
    }

    private handleWindowResize() {
        const mobileWidth = this.gridOptions?.mobileWidth || 1200;
        let newIsMobileMode = this.gridOptions.isMobileMode;
        let newIsMobileWidth = window.innerWidth < mobileWidth;
        
        if (newIsMobileWidth) {
            newIsMobileMode = true;
        }
        
        if (newIsMobileWidth !== this.isMobileWidth) {
            this.isMobileWidth = newIsMobileWidth;
        }

        if (newIsMobileMode !== this.gridOptions.isMobileMode) {
            this.toggleViewMode();
        }
    }
    
    /**
     * Resize event to set mobile mode.
     * 
     * @param event Event.
     */
    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.handleWindowResize();
    }
}